export default "__VITE_ASSET__CyDCB5e5__"